const es = {
  onboarding: {
    countryQuestion: "¡Entendido! 🌍\n\n¿En qué país estás?",
    countryPlaceholder: "¿En qué país estás?",
    letsGo: "¡Vamos!",
    summaryIntro: "🎉 ¡Genial, {name}! ¡Todo listo!",
    yourNameLabel: "tu nombre",
    baseLanguageLabel: "idioma base",
    goalsHint: "Puedes ajustar tu objetivo de vocabulario y la duración del curso en cualquier momento desde la página de Metas.",
    startLearning: "¡Empieza a aprender {destLang}!",
  },
  header: {
    learner: "Estudiante",
    home: "🏠 Inicio",
    allLessons: "📚 Todas las lecciones",
    currentLesson: "📖 Lección actual",
    flashcards: "🃏 Tarjetas",
    progress: "📈 Progreso",
    goals: "🎯 Objetivos",
    grammarLab: "📘 Gramática",
    more: "⋯ Más",
    myVocabulary: "📝 Mi Vocabulario",
    listenSpeak: "🎧 Escuchar y Hablar",
    signOut: "↩ Cerrar sesión",
  },
  lab: {
    title: "Laboratorio de Escuchar y Hablar",
    back: "Volver",
    intro: "Mantén una breve conversación hablada con Babi sobre un tema que ya has estudiado.",
    pickTopic: "Elige un tema que hayas terminado",
    noTopics: "Primero termina una lección y luego vuelve aquí para practicar el habla.",
    level: "Nivel {level}",
    talkAbout: "Habla con Babi sobre «{topic}»",
    speedLabel: "Velocidad de Babi",
    speedNormal: "Normal",
    speedSlow: "Lenta",
    speedNote: "La velocidad lenta usa más de tus minutos de voz para la misma respuesta.",
    startConversation: "Iniciar conversación",
    tapToStart: "Toca el micrófono y respóndele a Babi en turco.",
    continueConversation: "Responde la pregunta",
    finishSession: "Finalizar",
    voiceReviewHint: "Revisa lo que dijiste y confírmalo, o vuelve a intentarlo.",
    voiceConfirm: "Confirmar",
    voiceRedo: "Repetir",
    voiceDenied: "La voz no está disponible sin acceso al micrófono. Toca el ícono del micrófono cuando quieras intentarlo de nuevo.",
    lowBalanceWarning: "Te estás quedando sin minutos de voz para este ciclo mensual.",
    thinking: "Babi está pensando…",
    complete: "Sesión completada",
    completeSub: "Buena práctica. Vuelve cuando quieras para hablar de otro tema.",
    another: "Practicar otro tema",
    done: "Listo",
    replyError: "Babi no pudo responder en este momento. Inténtalo de nuevo en un instante.",
    tryAgain: "Reintentar",
    eliteUpsellTitle: "Escuchar y Hablar es una función Elite",
    eliteUpsellBody: "Tienes el plan Pro. Cambia a Elite en Ajustes para practicar el habla con Babi.",
    listenAgainButton: "Escuchar de nuevo",
    listenAgainPlaying: "Detener",
    translateButton: "Traducir",
    translating: "Traduciendo…",
    translateFailed: "No se pudo traducir — inténtalo de nuevo.",
    starsAriaLabel: "{stars} de 3",
    explainButton: "Explicar más",
    explaining: "Explicando…",
    explainFailed: "No se pudo obtener una explicación — inténtalo de nuevo.",
    recapHeading: "Informe de la conversación",
    recapTitle: "Tu resumen",
    recapAvgStars: "Promedio de esta sesión",
    recapTurnsCompleted: "{completed} de {total} turnos completados",
    recapErrorFree: "{n} turnos sin errores",
    recapMistakesByType: "Errores por tipo",
    recapCorrections: "Lo que se corrigió",
    voiceMinutesTitle: "Minutos de voz",
    voiceMinutesLeft: "{amount} de {total} restantes este ciclo",
    voiceMinutesNone: "No quedan minutos mensuales este ciclo",
  },
  dashboard: {
    greeting: "¡Hola, {name}! 👋",
    streakMsg: "¡Racha de {streak} días 🔥 — sigue así!",
    noStreak: "¡Empieza tu primera lección hoy!",
    streakProtectionDays: "{n} Días de Protección de Racha ganados 🛡️",
    dayInfo: "Idioma base: {lang} · Día {day} de {total}",
    dayStreak: "días seguidos",
    share: "Compartir",
    wordsLearned: "Palabras aprendidas",
    lessonsDone: "Lecciones completadas",
    goalComplete: "Objetivo completado",
    timeStudied: "Tiempo estudiado",
    hoursUnit: "Horas",
    paceTitle: "📊 Seguimiento de ritmo diario",
    statusAhead: "🚀 ¡{delta} palabras por delante!",
    statusBehind: "⚡ {delta} palabras por recuperar",
    statusOnTrack: "✅ ¡Exactamente en el ritmo!",
    paceTarget: "Objetivo: {wpd} palabras/día · Hoy: {today} palabras",
    paceExpected: "Esperado: {n}",
    paceGoal: "Objetivo: {n}",
    actionCurrentLesson: "Lección actual",
    actionAllLessons: "Todas las lecciones",
    actionFlashcards: "Tarjetas",
    actionProgress: "Mi progreso",
    actionGoals: "Mis objetivos",
    actionMyVocabulary: "Mi Vocabulario",
    actionGrammarLab: "Laboratorio de Gramática",
    actionListenSpeak: "Laboratorio de Escuchar y Hablar",
    lessonsSub: "{count} temas · {words} palabras",
    cardsDue: "¡{n} tarjetas para hoy!",
    allCaughtUp: "¡Todo al día! 🎉",
    progressSub: "Gráficos, precisión, crecimiento de vocabulario",
    myVocabSub: "Explora todas las palabras que has aprendido",
    listenSpeakSub: "Practica el habla con Babi",
    goalsSub: "{words} palabras · {days} días",
    apiCost: "💰 Rastreador de costos API",
    since: "desde {date}",
    resetBtn: "↺ Reiniciar",
    totalTokens: "tokens totales",
    inputTokens: "entrada",
    outputTokens: "salida",
    estCost: "costo est.",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "Consejo:",
    tips: [
      "En turco, el verbo siempre va al final de la oración — «Ben kahve içiyorum» significa «Yo café estoy-bebiendo.» ¡Absorbe los patrones!",
      "El turco usa armonía vocálica — los sufijos adaptan sus vocales a la última vocal del radical (p. ej. -lar/-ler, -da/-de). ¡Una vez que lo ves, todo encaja!",
      "El turco no tiene género gramatical. Sin sustantivos masculinos ni femeninos — ¡una cosa menos que memorizar comparado con el español o el francés!",
      "Los pronombres personales (ben = yo, sen = tú) suelen omitirse porque el sufijo verbal ya indica quién realiza la acción.",
      "El turco es fonéticamente regular — cada letra siempre se pronuncia igual. Lo que lees es exactamente lo que dices.",
      "La negación se forma añadiendo -me/-ma directamente al radical verbal: gel (ven) → gelme (no vengas), anla (entiende) → anlama.",
      "El turco usa posposiciones que van DESPUÉS del sustantivo: «İstanbul'da» = «en Estambul» (Estambul + sufijo locativo -da).",
      "El sufijo de plural sigue la armonía vocálica: -lar después de vocales posteriores (a, ı, o, u) y -ler después de vocales anteriores (e, i, ö, ü).",
      "El sufijo -ıyor/-iyor/-uyor/-üyor marca el presente continuo. Anlıyorum = Estoy entendiendo (anla + ıyor + um).",
      "Los verbos compuestos turcos combinan un sustantivo con etmek (hacer) u olmak (ser): teşekkür etmek (agradecer), hazır olmak (estar listo).",
    ],
  },
  lesson: {
    backBtn: "← Volver",
    topicOf: "Tema {order} de {total} · {words} palabras",
    translating: "Preparando la lección…",
    newWords: "✨ Palabras nuevas ({n})",
    alreadyLearned: "🔄 Ya aprendidas ({n})",
    practiceDialogue: "🎭 Práctica",
    generateDialogue: "🎭 Dame un diálogo de práctica",
    listenSpeakPractice: "🎧 Practicar en el Laboratorio de Escuchar y Hablar",
    generatingDialogue: "Babi está preparando tu diálogo…",
    newDialogue: "↺ Nuevo diálogo",
    lessonSaved: "🎉 ¡Lección guardada! Añadiendo {n} tarjetas nuevas…",
    alreadyTaken: "✅ Lección ya completada",
    markComplete: "✅ Marcar lección como completa y guardar tarjetas",
  },
  vocab: {
    structure: "Estructura",
    loadingExample: "Cargando…",
    limitReached: "↺ Límite alcanzado",
    anotherLeft: "↺ Otro ({n} restante)",
    anotherExample: "↺ Otro ejemplo",
    analyzing: "Analizando…",
    analyzed: "✓ Analizado",
    analyzeWord: "🔍 Analizar palabra",
    analysisIntro: "Aquí tienes el análisis gramatical paso a paso:",
    analysisError: "No se pudo cargar el análisis. Inténtalo de nuevo.",
    reportMistake: "🚩 Reportar error",
    reportWrongMeaning: "Significado de palabra incorrecto",
    reportWrongSentence: "Significado de oración incorrecto",
    reportOther: "Otro",
    reportChecking: "Verificando…",
    reportThanks: "✓ ¡Gracias por ayudarnos a mejorar!",
    reportNoIssue: [
      "No encontré ningún problema aquí — ¡esto me parece correcto!",
      "No veo ningún problema aquí — esto parece correcto.",
      "Todo parece estar en orden desde mi punto de vista.",
      "No pude identificar ningún problema; esto parece correcto tal como está escrito.",
      "Esto me parece bien — no tengo ninguna preocupación.",
      "Lo revisé y no encontré nada que necesite cambiarse.",
      "No noté ningún problema; la traducción parece correcta.",
      "Por lo que puedo ver, todo está correcto.",
      "No pude detectar ningún problema; esto me parece bien.",
    ],
    reportCheckError: "Tuve problemas para completar la verificación. Por favor, inténtalo de nuevo más tarde.",
    reportOkBtn: "OK, entendido",
    reportEscalateBtn: "Escalar a un revisor humano",
    reportEscalatedMsg: "✓ Enviado a nuestro equipo de revisión. ¡Gracias!",
    reportAlreadyFlaggedMsg: "✓ Esto ya ha sido señalado a nuestro equipo de revisión. ¡Gracias!",
  },
  allLessons: {
    title: "📚 Todas las lecciones",
    subtitle: "{count} temas · {words} palabras",
    searchPlaceholder: "🔍 Buscar temas o palabras…",
    noResults: "Ningún tema coincide con \"{search}\"",
    overwhelmedBanner: "Tienes {n} tarjetas por revisar. Revisa tus flashcards antes de comenzar nuevas lecciones.",
    overwhelmedLock: "Revisa las tarjetas primero",
    overwhelmedBtn: "Ir a las tarjetas →",
  },
  flashcards: {
    title: "Tarjetas",
    cardOf: "Tarjeta {current} de {total}",
    tapToReveal: "Toca para revelar",
    hearIt: "🔊 Escuchar",
    hearSentence: "🔊 Escucha la frase.",
    allConsolidated: "Todo consolidado",
    noDue: "No hay tarjetas pendientes ahora.\nTu memoria está bien descansada.",
    backToDashboard: "Volver al panel",
    sessionComplete: "Sesión completada",
    memoryRetention: "Eficiencia de memoria",
    forgotten: "Olvidado",
    struggled: "Costó",
    recalled: "Recordado",
    effortless: "Fácil",
    wordsConsolidated: "{retained} de {total} palabras consolidadas",
    wordsInProgress: "{retained} de {total} palabras en proceso",
    saveContinue: "Guardar y continuar",
    tomorrow: "Mañana",
    nDays: "{n} días",
    d1Title: "Comprensión",
    d1SubSkill: "Para mejorar las habilidades de lectura y escucha",
    d1Journey: "Las palabras nuevas comienzan su viaje aquí.",
    d1Due: "{n} pendientes",
    d1Listen: "Escuchar",
    d1ShowWord: "Mostrar la palabra",
    d2Title: "Producción",
    d2SubSkill: "Para mejorar las habilidades de habla y escritura",
    d2WillStart: "Comenzará después",
    d2Empty: "Las palabras llegan aquí una vez dominadas en el conjunto de comprensión.",
    d2ModalTitle: "¡Práctica de producción desbloqueada!",
    d2ModalBody: "Estas son palabras que ya reconoces bien. Ahora te entrenamos para producirlas — así es como pasas de entender el {targetLang} a hablarlo.",
    d2ModalBtn: "Entendido",
    leaveConfirmTitle: "Progreso de repaso sin guardar",
    leaveConfirmBody: "Has repasado tarjetas en esta sesión que aún no se han guardado. Si sales ahora sin guardar, ese progreso se perderá.",
    leaveConfirmSave: "Guardar y salir",
    leaveConfirmDiscard: "Descartar y salir",
    leaveConfirmCancel: "Cancelar",
    faq: {
      whyTwoQ: "¿Por qué dos mazos?",
      whyLaterQ: "¿Por qué el conjunto de producción comienza después?",
      whyReturnQ: "¿Por qué las tarjetas siguen volviendo?",
    },
  },
  grammarLab: {
    title: "📘 Laboratorio de Gramática",
    subtitle: "{count} temas de gramática para explorar",
    backBtn: "← Atrás",
    searchPlaceholder: "🔍 Buscar temas de gramática…",
    noResults: "Ningún tema de gramática coincide con \"{search}\"",
    allCategories: "Todas las categorías",
    allLevels: "Todos los niveles",
    notReviewedLabel: "No revisado",
    reviewedLabel: "Revisado",
    dueBadge: "{n} pendientes",
    explanationLabel: "Explicación",
    seeReference: "(ver {term})",
    ruleLabel: "Regla",
    formsLabel: "Formas",
    translatingNote: "Traduciendo al español...",
    practiceBtn: "▶ Practicar este tema",
    detailedExplanationBtn: "📖 Explicación detallada",
    practiceTitle: "Práctica",
    practiceQuestion: "¿Cómo se dice esto en turco?",
    practiceOf: "{current} de {total}",
    practiceCorrectFeedback: "¡Correcto!",
    practiceIncorrectFeedback: "No exactamente — la respuesta era {answer}.",
    practiceNext: "Siguiente →",
    practiceDone: "Práctica completada",
    practiceScore: "{correct} de {total} correctas",
    practiceNextReview: "Próximo repaso en {days} día{plural}",
    practiceReset: "Esta vez no — volverás a ver este tema mañana.",
    practiceAgainBtn: "Practicar de nuevo",
    practiceCloseBtn: "Listo",
    categories: {
      existential: "Existencial",
      noun_suffix: "Sufijo Nominal",
      case_suffix: "Sufijo de Caso",
      verb_conjugation: "Conjugación Verbal",
      question_particle: "Partícula Interrogativa",
      copula: "Cópula",
      modal_construction: "Construcción Modal",
      adjectives: "Adjetivos",
      case: "Caso",
      modality: "Modalidad",
      mood: "Modo",
      morphology: "Morfología",
      morphophonology: "Morfofonología",
      phonology: "Fonología",
      pronouns: "Pronombres",
      register: "Registro",
      syntax: "Sintaxis",
      tense: "Tiempo Verbal",
      voice: "Voz",
    },
    points: {
      GP0001: { title: "Existencia y Disponibilidad: var / yok", ruleSummary: "[lugar/poseedor] + [cosa] + var / yok" },
      GP0002: { title: "Sufijo de Plural: -ler / -lar", ruleSummary: "sustantivo + -ler (vocal anterior) / -lar (vocal posterior)" },
      GP0003: { title: "Caso Locativo: -de / -da / -te / -ta", ruleSummary: "sustantivo + -de/-da; -te/-ta tras consonante sorda" },
      GP0004: { title: "Caso Dativo: -e / -a", ruleSummary: "sustantivo + -e/-a; se inserta -y- de enlace tras vocal" },
      GP0005: { title: "Caso Ablativo: -den / -dan / -ten / -tan", ruleSummary: "sustantivo + -den/-dan; -ten/-tan tras consonante sorda" },
      GP0006: { title: "Caso Acusativo: -i / -ı / -u / -ü (objeto directo definido)", ruleSummary: "sustantivo + -i/-ı/-u/-ü; -y- de enlace tras vocal" },
      GP0007: { title: "Presente Continuo — Afirmativo: -iyor", ruleSummary: "raíz verbal + -iyor + terminación personal" },
      GP0008: { title: "Presente Continuo — Negativo: -mıyor / -miyor / -muyor / -müyor", ruleSummary: "raíz verbal + -mıyor/-miyor/-muyor/-müyor + terminación personal" },
      GP0009: { title: "Presente Continuo — Interrogativo: -iyor mu", ruleSummary: "raíz + -iyor + mu(+personal); onlar: raíz + -iyorlar + mı" },
      GP0010: { title: "Partícula Interrogativa Sí/No: mı / mi / mu / mü", ruleSummary: "[palabra] + partícula separada mı/mi/mu/mü ?" },
      GP0011: { title: "Pasado Simple (Definido): -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "raíz verbal + -di/-dı/-du/-dü (o -ti/... tras sorda) + terminación personal" },
      GP0012: { title: "Terminaciones del Verbo 'Ser/Estar' (Presente): -(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "predicado + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "Sufijos Posesivos: mi / tu / su (de él-ella) / nuestro / vuestro / su (de ellos)", ruleSummary: "(benim/senin/...) sustantivo + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "Expresar Deseo: -mek / -mak istemek", ruleSummary: "[infinitivo -mek/-mak] + istemek (conjugado)" },
      GP0015: { title: "Petición Cortés / Imperativo de 2ª Persona Plural: -in / -iniz", ruleSummary: "raíz verbal + -in/-ın/-un/-ün (cortés) o -iniz (más formal); -y- de enlace tras vocal" },
      GP0016: { title: "Suavización Consonántica: p/ç/t/k → b/c/d/ğ", ruleSummary: "[palabra terminada en p/ç/t/k, si sufre suavización léxica] + sufijo que empieza en vocal → b/c/d/ğ reemplaza la consonante final" },
      GP0017: { title: "Raíces Verbales Irregulares: gitmek, etmek, yemek, demek", ruleSummary: "git-→gid-, et-→ed-, ye-→yi-, de-→di- ante un sufijo que empieza en vocal" },
      GP0018: { title: "Raíces con Caída Vocálica antes de -iyor", ruleSummary: "[raíz verbal terminada en -e/-a átona] + -iyor → la vocal final cae, luego se añade -iyor" },
      GP0019: { title: "Vocales del Turco", ruleSummary: "8 vocales: a, e, ı, i, o, ö, u, ü — cada una es anterior/posterior Y no redondeada/redondeada" },
      GP0020: { title: "Armonía Vocálica", ruleSummary: "La vocal del sufijo coincide con la última vocal de la palabra: raíz anterior → vocal de sufijo anterior, raíz posterior → vocal de sufijo posterior (y redondeada/no redondeada para sufijos de 4 vías)" },
      GP0021: { title: "Caso Genitivo: -in/-ın/-un/-ün", ruleSummary: "[sustantivo] + in/ın/un/ün (armonía de 4 vías; -n- de enlace si el sustantivo termina en vocal)" },
      GP0022: { title: "Determinantes Posesivos (benim, senin, onun...)", ruleSummary: "Pronombre personal + sufijo genitivo: ben→benim, sen→senin, o→onun, biz→bizim, siz→sizin, onlar→onların" },
      GP0023: { title: "Tiempo Futuro: -ecek/-acak", ruleSummary: "[raíz] + (y) + ecek/acak (k→ğ ante terminación personal que empieza en vocal) + persona" },
      GP0024: { title: "Pasado Reportado (Evidencial): -miş", ruleSummary: "[raíz] + mış/miş/muş/müş (armonía de 4 vías) + terminación personal predicativa" },
      GP0025: { title: "Pasado Continuo: -iyordu", ruleSummary: "[raíz en forma -iyor] + du/dun/duk/dunuz (+ -lar se añade antes de -dı para 3ª pl.)" },
      GP0026: { title: "Habilidad: -ebilmek/-abilmek ('poder / ser capaz de') - afirmativo", ruleSummary: "[raíz] + (y)e/(y)a + bil + ir (siempre -ir, por la excepción fija del propio aoristo de bilmek) + persona" },
      GP0027: { title: "Orden de las Palabras", ruleSummary: "Por defecto: Sujeto - Objeto/Lugar - Verbo (el verbo va al final). Flexible para dar énfasis; el rol se marca con sufijos de caso, no por la posición." },
      GP0028: { title: "Conjunciones", ruleSummary: "ve (y), ama (pero), çünkü (porque), veya (o) - palabras invariables, sin conjugación de sufijos" },
      GP0029: { title: "Posposiciones (Preposiciones)", ruleSummary: "ile (con), için (para), gibi (como), kadar (hasta/tanto como), önce (antes), sonra (después) - todas siguen al sustantivo" },
      GP0030: { title: "Comparativos y Superlativos", ruleSummary: "daha + adjetivo (comparativo); en + adjetivo (superlativo); [sustantivo-ablativo] daha [adjetivo] = 'más ADJ que sustantivo'" },
      GP0031: { title: "Adverbios Turcos (frecuencia/grado)", ruleSummary: "çok (muy/mucho), az (un poco), hiç (nunca/en absoluto - se usa con un verbo negativo), bazen (a veces), şimdi (ahora)" },
      GP0032: { title: "Aoristo (Presente Simple / Habitual): -er/-ir/-ar/-ır", ruleSummary: "Polisilábico: [raíz]+ir/ır/ur/ür (terminada en consonante, regular) o [raíz]+r (terminada en vocal, regular). Monosilábico terminado en consonante: DIVIDIDO LÉXICAMENTE entre -Ar e -Ir - verificar cada verbo, no adivinar." },
      GP0033: { title: "Pasado Habitual: -erdi/-ırdı ('solía')", ruleSummary: "[raíz de aoristo] + di/dı/du/dü (4 vías, según la propia vocal de -ir/-ar) + persona" },
      GP0034: { title: "Futuro en el Pasado: -ecekti/-acaktı ('iba a')", ruleSummary: "[raíz de futuro] + ti (ensordecida, singular/1ª pl.) O + ler + di (sonora, 3ª pl., sin ensordecimiento porque -ler termina en 'r')" },
      GP0035: { title: "Condicional Irreal: -se/-sa (raíz desnuda)", ruleSummary: "[raíz] + se/sa (2 vías) + persona (m, n, -, k, niz, ler)" },
      GP0036: { title: "Necesidad: -malı/-meli ('deber / tener que')", ruleSummary: "[raíz] + malı/meli (2 vías) + (y) + terminación personal predicativa" },
      GP0037: { title: "Participio de Sujeto: -en/-an ('el que...')", ruleSummary: "[raíz] + en/an (2 vías); las raíces terminadas en vocal llevan -y- de enlace" },
      GP0038: { title: "Cláusula Temporal: -ince/-ınca ('cuando...')", ruleSummary: "[raíz terminada en consonante] + ince/ınca (2 vías, patrón confirmado); el patrón para raíces terminadas en vocal AÚN NO VERIFICADO" },
      GP0039: { title: "Comparación de los Tiempos Pasados", ruleSummary: "-di (presenciado) vs. -miş (reportado) vs. -iyordu (estaba haciendo) vs. -irdi (solía hacer)" },
      GP0040: { title: "Formas de Caso de los Pronombres Demostrativos: bu/şu/o", ruleSummary: "bu/şu/o + n (de enlace) + sufijo de caso" },
      GP0041: { title: "Demostrativos de Lugar: bura/şura/ora ('aquí/ahí')", ruleSummary: "bura/şura/ora + sufijo de caso (-y- de enlace solo antes del dativo)" },
      GP0042: { title: "Palabras Interrogativas", ruleSummary: "ne, kim, nerede, nasıl, kaç, ne zaman, neden - todas invariables" },
      GP0043: { title: "Caso Instrumental: -(y)le/-(y)la ('con / por medio de')", ruleSummary: "[sustantivo] + (y)le/(y)la (armonía de 2 vías; -y- de enlace si termina en vocal)" },
      GP0044: { title: "Sufijos Adjetivales 'Con/Sin': -lı/-siz", ruleSummary: "[sustantivo] + lı/li/lu/lü ('con') o sız/siz/suz/süz ('sin') - armonía de 4 vías" },
      GP0045: { title: "Incapacidad: -(y)AmA- ('no poder')", ruleSummary: "[raíz] + (y)e/(y)a + me/ma + terminación personal del aoristo negativo (m/mez-sin/mez/meyiz/mez-siniz/mez-ler)" },
      GP0046: { title: "Condicional Real: [raíz de aoristo] + -se/-sa ('si sucede X')", ruleSummary: "[raíz de aoristo] + se/sa (2 vías, según la propia vocal del sufijo de aoristo) + persona" },
      GP0047: { title: "Participio de Objeto: -DIk + posesivo ('que [sujeto] verbo-ó')", ruleSummary: "[raíz] + DIk (4 vías; se suaviza a ğ solo ante posesivo que empieza en vocal) + posesivo" },
      GP0048: { title: "Uso del Participio de Futuro (reutiliza las formas del tiempo futuro)", ruleSummary: "Las mismas formas superficiales que el tiempo futuro (see GP0023), usadas adjetivalmente ante un sustantivo en lugar de como verbo finito" },
      GP0049: { title: "Cláusulas Temporales: -DIğI zaman / -mADIğI zaman / -DIktan sonra", ruleSummary: "[participio de objeto] + zaman = 'cuando'; [-DIk desnudo] + ten + sonra = 'después de'" },
      GP0050: { title: "El Sufijo -ki (relativizador)", ruleSummary: "[sustantivo locativo / pronombre genitivo] + ki (INVARIABLE - sin armonía)" },
      GP0051: { title: "Duración: -DAn beri / -DIr ('desde / durante')", ruleSummary: "[tiempo]+den beri = 'desde X'; [duración]+dir/dır/dur/dür + tiempo presente = 'durante X (y sigue)'" },
      GP0052: { title: "Voz Pasiva: -Il/-In", ruleSummary: "terminada en consonante (no l): +Il/ıl/ul/ül; terminada en l: +In/ın/un/ün; terminada en vocal: +n" },
      GP0053: { title: "Causativo: -t/-DIr/-Ir (solo lista curada - léxicamente complejo)", ruleSummary: "Alomorfo determinado léxicamente - verificar cada verbo individualmente, no generalizar" },
      GP0054: { title: "Reflexivo: -In/-ın ('hacer X a uno mismo')", ruleSummary: "[raíz] + In/ın/un/ün (o n tras vocal) - significado reflexivo, determinado léxicamente como la pasiva (see GP0052)" },
      GP0055: { title: "Recíproco: -Iş/-ış ('hacerse X el uno al otro')", ruleSummary: "[raíz] + Iş/ış/uş/üş (4 vías) - acción mutua/conjunta" },
      GP0056: { title: "Optativo (Que yo / Vamos a): -(y)eyim/-(y)elim", ruleSummary: "[raíz] + (y)eyim (1ª sg.) / (y)elim (1ª pl.) - armonía de 2 vías" },
      GP0057: { title: "Registro Narrativo: -mış Repetido (narración de historias)", ruleSummary: "-mış se usa repetidamente a lo largo de una narración, no solo una vez, para mantener el registro narrativo" },
      GP0058: { title: "'Ne kadar da' (intensificador - '¡qué...!')", ruleSummary: "Ne kadar da + [adjetivo] = intensificador exclamativo" },
      GP0059: { title: "Converbo de Modo: -ArAk ('haciendo / al hacer X')", ruleSummary: "[raíz] + arak/erek (armonía de 2 vías)" },
      GP0060: { title: "Converbo Secuencial: -Ip ('y, habiendo hecho X')", ruleSummary: "[raíz] + Ip/ıp/up/üp (4 vías) - solo el último verbo de la cadena lleva tiempo" },
      GP0061: { title: "Cláusula Causal: -DIğI için ('porque X [sucedió]')", ruleSummary: "[participio de objeto] (see GP0047) + için (see GP0029) = 'porque X'" },
      GP0062: { title: "'Diye' ('pensando/diciendo que...')", ruleSummary: "[cláusula] + diye + [cláusula principal] = 'pensando/en base a que [cláusula], [cláusula principal]'" },
      GP0063: { title: "'Olarak' ('como X / en calidad de X')", ruleSummary: "[sustantivo] + olarak = 'como [sustantivo]'" },
      GP0064: { title: "'Tarafından' (Marcador de Agente Pasivo - 'por X')", ruleSummary: "[frase nominal] + tarafından + [verbo pasivo] (see GP0052)" },
      GP0065: { title: "'Rağmen' ('a pesar de')", ruleSummary: "[sustantivo + dativo] (see GP0004) + rağmen = 'a pesar de X'" },
      GP0066: { title: "'Göre' ('según')", ruleSummary: "[sustantivo/pronombre + dativo] + göre = 'según X'" },
      GP0067: { title: "Verbos Semi-Modales + Complemento Dativo", ruleSummary: "[sustantivo/verbo-mA] + dativo + alışmak/başlamak/çalışmak/karar vermek/izin vermek/benzemek/inanmak/üzülmek" },
      GP0068: { title: "Expresiones Epistémicas y Evidenciales", ruleSummary: "gibi geliyor = 'parece que' (see GP0029) (see GP0007); -mış olmalı = 'debe haber' (see GP0024) (see GP0036); -mış görünmek = 'parece haber'; bildiğim kadarıyla = 'que yo sepa' (see GP0047) (see GP0029) (see GP0043)" },
      GP0069: { title: "Verbos Comunes + Objeto Acusativo: unutmak, sormak, hatırlamak", ruleSummary: "[sustantivo + acusativo] (see GP0006) + unutmak/sormak/hatırlamak" },
      GP0070: { title: "Konuşmak vs. Söylemek ('hablar' vs. 'decir')", ruleSummary: "konuşmak = acto de hablar (idioma/persona); söylemek = decir [algo específico], objeto acusativo" },
    },
  },
  placementTest: {
    title: "🎯 Prueba de nivel",
    offerTitle: "¿Ya sabes algo de turco?",
    offerBody: "Haz una breve prueba de nivel — unas 20 preguntas — para encontrar tu punto de partida. Ajustaremos tu Lección actual, pero todos los temas seguirán abiertos para explorar.",
    startBtn: "Empezar prueba",
    notNowBtn: "Ahora no",
    roundLabel: "Ronda {round} de {totalRounds}",
    questionLabel: "Pregunta {n} de {total}",
    notSureOption: "No estoy seguro/a",
    notSureHint: "(Selecciona la quinta opción si no estás 100 % seguro/a.)",
    wordPrompt: "¿Qué significa esta palabra?",
    listeningPrompt: "Escucha y selecciona la palabra que oyes",
    listeningReplay: "Reproducir de nuevo",
    preparingRound: "Preparando tus preguntas…",
    finishBtn: "Ver mi resultado",
    resultsTitle: "Tu resultado de nivel",
    resultsLevel: "Te hemos ubicado en {level}",
    resultsBody: "Tu Lección actual ahora empieza en este nivel. Aun así puedes explorar cualquier tema anterior o posterior desde Todas las lecciones.",
    continueBtn: "Continuar",
  },
  goals: {
    title: "🎯 Mis objetivos",
    displayName: "Nombre de pantalla",
    namePlaceholder: "Tu nombre…",
    vocabTarget: "Objetivo de vocabulario",
    words: "palabras",
    minWords: "1.500 mín",
    midWords: "2.000",
    maxWords: "3.500 máx",
    courseDuration: "Duración objetivo del curso",
    months: "Meses",
    month: "mes",
    monthsPlural: "meses",
    daysSummary: "= {days} días",
    baseLanguage: "Idioma base",
    otherLanguage: "Otros idiomas (próximamente)",
    selectLanguage: "Selecciona un idioma…",
    ok: "OK",
    langNames: {
      English: "Inglés", Farsi: "Persa", Arabic: "Árabe",
      French: "Francés", German: "Alemán", Spanish: "Español",
      Russian: "Ruso", Portuguese: "Portugués", Chinese: "Chino",
      Turkish: "Turco", Hindi: "Hindi", Italian: "Italiano",
    },
    targetLanguage: "Idioma objetivo",
    targetLangNames: {
      Turkish: "Turco",
    },
    wordsLbl: "palabras",
    wordsPerDay: "palabras/día",
    daysLbl: "días",
    saved: "✅ ¡Objetivos guardados!",
  },
  progress: {
    title: "📈 Mi progreso",
    memDistTitle: "Distribución de estados de memoria · {n} tarjetas",
    inAcquisition: "En adquisición",
    rooted: "Arraigado",
    fluent: "Fluido",
    deeplyRetained: "Profundamente retenido",
    acqDesc: "< 3d de estabilidad",
    rootedDesc: "3 – 21d de estabilidad",
    fluentDesc: "21 – 90d de estabilidad",
    retainedDesc: "90d+ de estabilidad",
    forecastTitle: "Previsión de repaso — próximos 15 días",
    cardsDue: "Tarjetas pendientes",
    today: "Hoy",
    tmrw: "Mañ.",
    plusDays: "+{n}d",
    todayFull: "Hoy",
    tmrwFull: "Mañana",
    plusDaysFull: "+{n} días",
    goalProgress: "Progreso general hacia el objetivo",
    wordsLearned: "{learned} / {target} palabras aprendidas",
    vocabGrowth: "Crecimiento de vocabulario",
    noChart: "¡Completa tu primera lección para ver el gráfico! 📚",
    wordsLearnedSeries: "Palabras aprendidas",
    topicRings: "Anillos de memoria por tema",
    quickStats: "Estadísticas rápidas",
    dayStreak: "días seguidos 🔥",
    lessonsDone: "lecciones completadas",
    totalStudy: "estudio total",
    avg14Day: "promedio 14 días",
    minUnit: "min",
    dayLabel: "Día {n}",
    cards: "tarjetas",
  },
  myVocab: {
    title: "📝 Mi Vocabulario",
    summaryTitle: "{n} Palabras Encontradas",
    searchPlaceholder: "🔍 Busca tus palabras…",
    allStatuses: "Todos los estados",
    noResults: "Ninguna palabra coincide con \"{search}\"",
    noWords: "¡Completa una lección para empezar a construir tu vocabulario! 📚",
    completedTopicsTitle: "Temas Completados ({n} de {total})",
    noDate: "—",
  },
  badges: {
    newbie: "Novato",
    wordExplorer: "Explorador de Palabras",
    wordNerd: "Nerd de las Palabras",
    wordWizard: "Mago de las Palabras",
    rockstar: "Rockstar",
    expert: "Experto",
    champion: "Campeón",
  },
  memStates: {
    inAcquisition: "En adquisición",
    rooted: "Arraigado",
    fluent: "Fluido",
    deeplyRetained: "Profundamente retenido",
  },
  chat: {
    subtitle: "Tu tutor de turco",
    greetWords: ["Hola", "Ey", "Qué tal"],
    greeting: "{greet} {name},\n\nPregúntame sobre el turco — gramática, vocabulario, cultura — o sobre cómo usar esta aplicación.",
    placeholder: "Pregunta sobre el turco o la app…",
    error: "Lo siento, no pude conectarme. Por favor, inténtalo de nuevo.",
    escalationFallback: "Lo siento, no pude ayudarte del todo con eso. Se lo he notificado a nuestro equipo y recibirás una respuesta por correo electrónico — normalmente en 2 días hábiles. También puedes escribirnos directamente a support@speafy.com.",
    welcome: "¡Hola, {name}! 👋 ¡Bienvenido/a a Speafy! Soy Babi, y estoy aquí para dos cosas: ayudarte a conocer la app y responder cualquier pregunta que tengas sobre {targetLanguage}.\n\nEmpieza con la lección actual, o elige un tema de «Todas las lecciones». No olvides marcar cada lección como completada cuando termines, y luego revisar las Tarjetas.\n\nPregúntame cuando quieras — sobre la app o sobre {targetLanguage}.\n\n¡Buena suerte en tu viaje de aprendizaje! 😊",
    lessonLimit: "¡Ya completaste {limit} lecciones hoy — increíble esfuerzo! 🌟\n\nPara que tu aprendizaje sea sostenible y evitar sobrecargar tu cola de tarjetas, hay un límite diario de {limit} lecciones.\n\nDale a tu cerebro tiempo para consolidar lo aprendido hoy. ¿Qué tal una sesión de repaso de tarjetas en su lugar?\n\n¡Aquí estaré mañana para más! 😊",
    streakDecayed: "¡Bienvenido de nuevo! 👋 Estuviste fuera {days} día(s). Gracias a los {protection} Días de Protección de Racha 🛡️ que ganaste, tu racha solo bajó de {oldStreak} a {newStreak} en lugar de desaparecer por completo. ¡Sigamos construyendo!",
    streakWiped: "¡Bienvenido de nuevo! 👋 Estuviste fuera {days} día(s) — más de los {protection} Días de Protección de Racha 🛡️ que tenías acumulados, así que tu racha reinició en 1. Toda racha empieza en algún punto — ¡reconstruyámosla!",
    weeklyRecapFallback: "¡Hola! 👋 Quería traerte tu resumen semanal, pero estoy teniendo problemas para prepararlo ahora mismo. Aun así, un aviso rápido — llevas una racha de {streak} día(s), ¡sigue así! 🔥",
    dailyPlanQuestion1: "¡Hola! 👋 ¿Cuánto tiempo tienes para estudiar hoy?",
    dailyPlanQuestion2: "¡Hola! 😊 Tengo un plan de estudio para ti — ¿cuántos minutos puedes dedicar hoy?",
    dailyPlanQuestion3: "¿Listo/a para el plan de hoy? 🎯 Solo dime más o menos cuánto tiempo tienes.",
    dailyPlanClarify: "Perdona, no entendí bien. ¿Puedes darme un número aproximado, como '20' o '30 minutos'?",
    dailyPlanUnreasonable: "¡Eso no suena a una sesión de estudio típica! ¿Puedes darme algo entre 5 minutos y unas 5 horas?",
    dailyPlanGiveUp: "No pasa nada — cuando estés listo/a, ve a Flashcards o a tu Lección Actual y ¡empieza! 😊",
    dailyPlanFallback: "Ya anoté tu tiempo disponible, pero estoy teniendo problemas para armar el plan de hoy ahora mismo. Mientras tanto, ¡Flashcards siempre es una buena opción si tienes tarjetas pendientes! 😊",
    sendBtn: "Enviar",
    askBabi: "Preguntar a Babi",
    voiceConsentTitle: "¿Activar el chat de voz con Babi?",
    voiceConsentBody: "Babi usará tu micrófono para escucharte y tu altavoz para responderte. Tu voz se convierte en texto — la grabación de audio en sí nunca se guarda. El texto puede conservarse hasta 30 días. Consulta nuestra Política de Privacidad para más detalles.",
    voiceConsentPrivacyLink: "Política de Privacidad",
    voiceConsentAllow: "Permitir micrófono",
    voiceConsentDecline: "Ahora no",
    voiceDenied: "El chat de voz no está disponible sin acceso al micrófono. Puedes seguir chateando escribiendo — toca el ícono del micrófono cuando quieras intentarlo de nuevo.",
    voiceDeviceInUse: "Parece que tu micrófono está siendo usado en otra parte — cierra otras apps que lo estén usando e inténtalo de nuevo.",
    voiceError: "Algo salió mal con el chat de voz. Inténtalo de nuevo.",
    voiceStarting: "Iniciando… espera un momento",
    voiceListening: "Escuchando…",
    voiceProcessing: "Entendiendo…",
    voiceReviewHint: "Toca para editar, o esto se enviará automáticamente en unos segundos.",
    voiceSendNow: "Enviar ahora",
    voiceDiscard: "Descartar",
    voiceEditTranscript: "Editar lo que Babi escuchó",
    voiceBadgeLabel: "Enviado por voz",
    voiceDidntCatch: "No entendí eso — toca el micrófono para intentarlo de nuevo.",
    voiceSpeaking: "Babi está hablando…",
    voiceTtsUnavailable: "El audio no estuvo disponible para esa respuesta — mostrando el texto en su lugar.",
    voiceTtsUnavailableLanguage: "La respuesta hablada de Babi aún no está disponible en {language}.",
    voiceTapToHear: "Toca para escuchar la respuesta de Babi",
    voiceNotEntitled: "El chat de voz con Babi es una función premium — mejora tu plan para usarla.",
    voiceNoBalance: "Has usado todos tus minutos de voz de este ciclo. Se renovarán en el próximo ciclo.",
    voiceOtherTabActive: "El chat de voz ya está activo en otra pestaña.",
    voiceLowBalanceNudge: "Te quedan pocos minutos de voz este ciclo.",
    voiceLowMinutesHeadsUp: "Te quedan pocos minutos de voz este ciclo.",
    voiceGetMoreMinutes: "Obtener más minutos",
    voiceStopBtn: "Detener",
    voiceMicButtonLabel: "Chat de voz",
    voiceBannerDismiss: "Descartar",
  },
  settings: {
    title: "Configuración",
    accountSection: "Cuenta",
    linkedGoogle: "Vinculado con Google",
    emailAccountBadge: "Cuenta de correo electrónico",
    changeNameBtn: "Cambiar nombre de usuario",
    nameSaveBtn: "Guardar",
    nameCancelBtn: "Cancelar",
    nameSaving: "Guardando…",
    passwordLabel: "Contraseña",
    passwordSub: "Enviar un enlace de restablecimiento a tu correo",
    passwordSent: "Enviado ✓",
    passwordResetBtn: "Restablecer",
    subscriptionSection: "Suscripción",
    subscriptionAdminLabel: "Cuenta de administrador",
    subscriptionAdminSub: "Tienes acceso completo y permanente a todas las funciones.",
    subscriptionReviewerLabel: "Acceso de revisor",
    subscriptionReviewerSub: "Tienes acceso gratuito a todas las funciones como revisor de la aplicación.",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "Anual",
    subscriptionPlanMonthly: "Mensual",
    subscriptionRenews: "Se renueva el {date}",
    subscriptionActive: "Activa",
    subscriptionManageLink: "Facturación y facturas",
    subscriptionCancelLink: "Cancelar o pausar la suscripción",
    subscriptionPaymentFailedLabel: "Tu último pago falló",
    subscriptionPaymentFailedSub: "El pago falló el {date}",
    subscriptionPaymentFailedSubNoDate: "Actualiza tu método de pago para conservar el acceso Pro",
    subscriptionUpdatePaymentLink: "Actualizar método de pago ↗",
    subscriptionCancelledPending: "Tu plan finaliza el {date} — conservarás el acceso Pro hasta entonces",
    subscriptionPausedLabel: "Suscripción en pausa",
    subscriptionPausedSub: "Se reanuda automáticamente el {date} — se te cobrará el importe completo de un nuevo período a menos que la reanudes antes",
    subscriptionPausedSubNoDate: "Se reanuda automáticamente después de 3 meses a menos que la reanudes antes",
    subscriptionResumeBtn: "Reanudar ahora",
    subscriptionResuming: "Reanudando…",
    pausePendingLabel: "Pausa programada",
    pausePendingSub: "Entra en vigor el {date}, al final de tu período de facturación actual",
    manageOfferTitle: "¿Estás pensando en cancelar?",
    manageOfferSub: "Pausa en su lugar — conservarás tu progreso hasta el {date}, y luego se reanudará automáticamente y se te cobrará el importe completo de un nuevo período después de 3 meses, a menos que la reanudes antes.",
    manageOfferPauseBtn: "Pausar en su lugar",
    manageOfferContinueLink: "Cancelar de todos modos",
    manageOfferDismiss: "No, gracias",
    pauseOfferLabel: "¿Necesitas un descanso?",
    pauseOfferSub: "Pausa tu suscripción durante 3 meses en lugar de cancelarla — conserva tu progreso, reanuda cuando quieras.",
    pauseOfferBtn: "Pausar suscripción",
    pauseConfirmP1: "¿Pausar tu suscripción a Speafy Pro?",
    pauseConfirmC1: "Tu período de facturación actual continúa hasta el {date} — conservas todo lo que ya has pagado.",
    pauseConfirmC2: "Mientras esté en pausa, las nuevas Lecciones quedan bloqueadas (igual que un plan gratuito vencido), pero puedes seguir repasando tus Tarjetas normalmente.",
    pauseConfirmC3: "La pausa dura 3 meses fijos. Si no la reanudas manualmente antes de ese plazo, se reanudará automáticamente y se te cobrará el importe completo de un nuevo período.",
    pauseConfirmBtn: "Confirmar pausa",
    pausing: "Pausando…",
    pauseFailedGeneric: "Algo salió mal al pausar tu suscripción. Inténtalo de nuevo o contacta con soporte.",
    manageLinkLoading: "Cargando…",
    manageLinkFailedGeneric: "No se pudo cargar un enlace de gestión ahora mismo. Inténtalo de nuevo.",
    resumeConfirmP1: "¿Reanudar tu suscripción a Speafy Pro ahora?",
    resumeConfirmC1: "Se te cobrará el importe completo de un nuevo período de facturación de inmediato.",
    resumeConfirmBtn: "Sí, reanudar ahora",
    resumeFailedGeneric: "Algo salió mal al reanudar tu suscripción. Inténtalo de nuevo o contacta con soporte.",
    subscriptionLastCharge: "Último cargo: {amount} el {date} — {status}",
    subscriptionLastChargePaid: "Pagado",
    subscriptionLastChargeFailed: "Fallido",
    tierChangePendingLabel: "Cambio de plan programado",
    tierChangePendingToElite: "Cambiando a Elite el {date}",
    tierChangePendingToBasic: "Cambiando a Pro el {date}, al final de tu periodo de facturación actual",
    tierUpgradeToEliteLink: "Mejorar a Elite",
    tierDowngradeToBasicLink: "Volver a Pro",
    tierUpgradeConfirmTitle: "¿Mejorar a Elite?",
    tierUpgradeConfirmSub: "Se te cobrará la diferencia prorrateada hoy, y obtendrás las 3 horas de conversación de voz de Elite con Babi de inmediato — {price}/{interval} en adelante.",
    tierDowngradeConfirmTitle: "¿Volver a Pro?",
    tierDowngradeConfirmSub: "Mantendrás Elite hasta el {date}, y luego pasarás a Pro en tu próxima fecha de facturación — sin cargo hoy.",
    tierUpgradeConfirmBtn: "Sí, mejorar ahora",
    tierDowngradeConfirmBtn: "Sí, volver a Pro",
    tierChangeBusy: "Actualizando…",
    tierChangeFailedGeneric: "Algo salió mal al cambiar tu plan. Inténtalo de nuevo o contacta con soporte.",
    voiceMinutesLabel: "Minutos de voz ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "Prueba",
    voiceTierAdmin: "Admin",
    voiceTierViewer: "Observador",
    voiceMinutesUsed: "{used} usados de {limit} este ciclo",
    voiceMinutesPurchasedExtra: "Además, {extra} compradas — se usan cuando se agotan tus minutos mensuales y nunca caducan",
    yourDataSection: "Tus Datos",
    marketingLabel: "Consentimiento de Comunicaciones de Marketing",
    marketingSub: "Actualizaciones, notificaciones y ofertas especiales",
    voiceConsentLabel: "Chat de Voz con Babi",
    voiceConsentSub: "Permite que Babi te escuche y responda en voz alta",
    privacyLegalSection: "Privacidad, Términos y Legal",
    privacyPolicyLabel: "Política de Privacidad",
    privacyPolicySub: "Cómo recopilamos, usamos y protegemos tus datos",
    viewLink: "Ver",
    termsLabel: "Términos de Servicio",
    termsSub: "Normas y condiciones que rigen tu uso",
    refundLabel: "Política de Reembolso",
    refundSub: "Elegibilidad y cómo solicitar un reembolso",
    cookieSettingsLabel: "Configuración de Cookies",
    cookieSettingsSub: "Gestiona las cookies analíticas y funcionales",
    manageLink: "Gestionar",
    privacySection: "Privacidad y datos",
    exportLabel: "Exportar mis datos",
    exportSub: "Descargar un archivo JSON de tu perfil, progreso y tarjetas",
    exportBtn: "Exportar",
    exportDone: "✓ Descargado",
    cacheLabel: "Caché local",
    cacheSub: "El progreso de aprendizaje y las frases de ejemplo se guardan en tu navegador para mayor velocidad.",
    cookieLabel: "Configuración de cookies y privacidad",
    cookieSub: "Las preferencias de análisis y cookies se gestionan en el sitio web de Speafy",
    privacyLink: "Política de privacidad ↗",
    aboutSection: "Acerca de",
    aiTutorLabel: "Tutor de IA",
    aiTutorSub: "Impulsado por Claude Sonnet — Anthropic",
    algoLabel: "Algoritmo de memoria",
    algoSub: "FSRS v4.5 — Planificador de repetición espaciada",
    learningSection: "Aprendizaje",
    placementTestLabel: "Prueba de nivel",
    placementTestSubNew: "Encuentra tu nivel de partida con una prueba rápida",
    placementTestSubRetake: "Último nivel: {level} · puedes repetirla cuando quieras",
    placementTestBtnNew: "Hacer la prueba",
    placementTestBtnRetake: "Repetir la prueba",
    versionLabel: "Versión",
    appearanceSection: "Apariencia",
    darkModeLabel: "Modo oscuro",
    darkModeSub: "Cambiar a un esquema de colores oscuro",
    largeTextLabel: "Texto grande",
    largeTextSub: "Aumenta el tamaño del texto para facilitar la lectura",
    babiCheckinsSection: "Check-ins de Babi",
    babiDailyNudgeLabel: "El aviso diario de Babi",
    babiDailyNudgeSub: "Babi te pregunta cuánto tiempo tienes y te sugiere un plan de estudio cada día",
    babiWeeklyReportLabel: "El informe semanal de Babi",
    babiWeeklyReportSub: "Un resumen semanal de tu progreso, una vez por semana",
    dangerSection: "Zona de peligro",
    resetLabel: "Restablecer todo el progreso",
    resetSub: "Borra tu racha, tarjetas y historial de lecciones. No se puede deshacer.",
    resetBtn: "Restablecer",
    resetConfirmP1: "¿Restablecer todo el progreso? Esto eliminará permanentemente:",
    resetConfirmC1: "Todas las {n} tarjetas y sus datos de memoria",
    resetConfirmC2: "Tu racha ({n} días) e historial de estudio",
    resetConfirmC3: "Todos los registros de lecciones completadas, en cada idioma que estés aprendiendo",
    resetConfirmC4: "Tu progreso de repaso en el Laboratorio de Gramática",
    resetConfirmP2: "Tu cuenta, nombre y configuración de idioma se conservarán.",
    resetConfirmBtn: "Sí, restablecer todo",
    resetting: "Restableciendo…",
    resetDone: "✅ ¡Progreso restablecido! Empiezas de cero.",
    deleteLabel: "Eliminar cuenta",
    deleteSub: "Elimina permanentemente tu cuenta y todos los datos. No se puede deshacer.",
    deleteBtn: "Eliminar cuenta",
    deleteConfirmP1: "¿Eliminar permanentemente tu cuenta de Speafy? Esto eliminará de forma inmediata e irreversible:",
    deleteConfirmC1: "Tu perfil (nombre, idioma, objetivos)",
    deleteConfirmC2: "Todas las {n} tarjetas y datos de memoria",
    deleteConfirmC3: "Tu historial completo de aprendizaje y racha",
    deleteConfirmC4: "Tu cuenta de autenticación de Firebase",
    deleteConfirmPrompt: "Escribe DELETE (en mayúsculas) para confirmar:",
    deleteConfirmBtn: "Eliminar permanentemente mi cuenta",
    deleting: "Eliminando…",
    cancelBtn: "Cancelar",
  },
  trial: {
    daysLeftBadge: "⏱ {n} días restantes",
    expiredBadge: "Prueba finalizada · Mejorar ↑",
    pausedBadge: "⏸ Pausada",
    proBadge: "✦ Plan Pro",
    eliteBadge: "✦ Plan Elite",
  },
  paywall: {
    back: "← Volver",
    title: "Mejorar a Speafy Pro",
    subTrialExpired: "Tu período de prueba ha terminado. Mejora para seguir aprendiendo.",
    subDefault: "Desbloquea todas las lecciones y la revisión de tarjetas.",
    features: [
      "Todas las {count} lecciones completamente desbloqueadas",
      "Chat ilimitado con Babi, tu tutor de IA",
      "Revisión inteligente de tarjetas FSRS",
      "Seguimiento de progreso y análisis de memoria",
      "Audio nativo en cada palabra",
      "Diálogos de práctica",
      "Interfaz multilingüe",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "Todo lo de Speafy Pro",
      "Laboratorio de Escuchar y Hablar — práctica de conversación guiada con Babi",
      "3 horas de conversación de voz con Babi cada mes",
      "Compra minutos de voz extra en cualquier momento — $3/hora",
    ],
    billingMonthly: "Mensual",
    billingYearly: "Anual",
    saveBadge: "Ahorra 25%",
    pricePerMonth: "/mes",
    priceBilledYearly: "facturado anualmente",
    cta: "Iniciar Speafy Pro →",
    ctaElite: "Iniciar Speafy Elite →",
    fine: "Cancela en cualquier momento · Pago seguro vía Paddle",
    bannerExpired: "Tu período de prueba gratuita ha terminado.",
    bannerActive: "Prueba gratuita — {n} días restantes.",
    bannerBtn: "Mejorar ↑",
    settingsFreePlan: "Plan Gratuito",
    pausedTitle: "Tu suscripción está en pausa",
    pausedSub: "Reanuda tu suscripción en Ajustes para desbloquear nuevas lecciones de nuevo.",
    pausedGoToSettingsBtn: "Ir a Ajustes",
    alreadyProTitle: "¡Ya eres Pro!",
    alreadyProSub: "Tu suscripción está activa — no necesitas comprar de nuevo.",
    alreadyProGoHomeBtn: "Ir a Inicio",
    settingsTrialRemaining: "Prueba — {n} días restantes",
    settingsTrialEnded: "Prueba finalizada — mejora para desbloquear todas las lecciones",
    settingsFreeForever: "Continúa donde lo dejaste — mejora para desbloquear todas las lecciones",
    settingsUpgradeBtn: "Mejorar",
  },
  authAction: {
    verifyingTitle: "Verificando tu correo electrónico…",
    verifiedTitle: "¡Tu correo electrónico está verificado!",
    verifiedBody: "Todo listo. Continúa en Speafy para seguir aprendiendo.",
    continueBtn: "Continuar a Speafy →",
    verifyErrorTitle: "Este enlace ha caducado",
    verifyErrorBody: "Este enlace de verificación ya no es válido. Inicia sesión y te enviaremos uno nuevo.",
    resendBtn: "Reenviar correo de verificación",
    resendSent: "Enviado ✓",
    resendError: "No se pudo reenviar. Inténtalo de nuevo en un momento.",
    signInBtn: "Iniciar sesión",
    verifyingReset: "Comprobando tu enlace…",
    resetTitle: "Restablece tu contraseña",
    resetBodyFor: "Elige una nueva contraseña para {email}",
    newPasswordPh: "Nueva contraseña",
    confirmPasswordPh: "Confirma la nueva contraseña",
    resetSubmitBtn: "Restablecer contraseña",
    resettingBtn: "Restableciendo…",
    resetSuccessTitle: "¡Contraseña actualizada!",
    resetSuccessBody: "Tu contraseña se ha cambiado. Inicia sesión con tu nueva contraseña.",
    resetErrorTitle: "Este enlace ha caducado",
    resetErrorBody: "Este enlace de restablecimiento de contraseña ya no es válido. Solicita uno nuevo desde la pantalla de inicio de sesión.",
    passwordMismatch: "Las contraseñas no coinciden.",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres.",
    genericError: "Algo salió mal. Inténtalo de nuevo.",
    invalidTitle: "Este enlace no es válido o ha caducado",
    invalidBody: "El enlace que seguiste ya no es válido. Vuelve a Speafy e inténtalo de nuevo.",
    backToSignIn: "Volver al inicio de sesión",
  },

  // Teacher-partner affiliate disclosure — FINALIZED wording, do not edit/re-translate.
  // `reviewed: false` → a native speaker flips it to `true` after confirming. See strings.js.
  affiliate: {
    disclosure: {
      text: "Aviso rápido: si te suscribes a Speafy a través de mi enlace, yo recibo una pequeña comisión; a ti no te cuesta nada extra.",
      reviewed: false,
    },
    // Promo message — FINALIZED + native-verified. `{{referral_link}}` is a literal placeholder. See strings.js.
    promoTemplate: {
      text: "¡Hola a todos! Quiero recomendarles una aplicación que es un excelente complemento para nuestras clases: Speafy. Sigue exactamente los temas que estudiamos juntos, y pueden practicar conversación en cualquier momento con una compañera de conversación con IA llamada Babi. Es gratis para empezar, y yo recibiré un informe semanal sobre su progreso, así que podré ver cómo les va entre nuestras sesiones. Regístrense a través de este enlace para quedar vinculados a mí como su profesor: {{referral_link}}",
      reviewed: true,
    },
  },

  teacherDash: {
    link: "Panel del profesor",
    title: "Panel del profesor",
    backHome: "Volver al inicio",
    studentBadge: "Tu profe: {name}",
    intro: "Todo lo que necesitas para traer a tus alumnos a Speafy y seguir su progreso.",
    referralTitle: "Tu enlace de referido",
    referralBody: "Comparte este enlace con tus alumnos. Cualquiera que se registre a través de él queda vinculado a ti como su profesor.",
    copy: "Copiar enlace",
    copied: "Copiado",
    shareText: "¡Únete a mí en Speafy y aprendamos un idioma juntos! {link}",
    shareTelegramText: "¡Únete a mí en Speafy y aprendamos un idioma juntos!",
    shareEmailSubject: "Únete a mí en Speafy",
    shareWhatsapp: "WhatsApp",
    shareTelegram: "Telegram",
    shareEmail: "Correo",
    shareSms: "SMS",
    shareMore: "Más",
    studentsTitle: "Tus alumnos",
    studentsLoading: "Cargando tus alumnos…",
    studentsError: "No hemos podido cargar tus alumnos ahora mismo.",
    retry: "Reintentar",
    studentsEmpty: "Aún no tienes alumnos. Comparte tu enlace de referido: los alumnos que se unan a través de él aparecerán aquí.",
    colName: "Alumno",
    colJoined: "Se unió",
    colStatus: "Suscripción",
    colCommission: "Comisión ganada",
    colGrammar: "Enfoque gramatical",
    statusActive: "Activa",
    statusTrial: "Prueba",
    statusNone: "Sin suscripción",
    commissionNote: "Esto es lo que has ganado de cada estudiante en total. Tu saldo disponible para pago se muestra a continuación.",
    commissionCapReached: "Período de 12 meses finalizado",
    grammarNote: "Los datos de errores gramaticales solo se muestran para estudiantes con una suscripción activa.",
    studentUnnamed: "Alumno",
    curriculumTitle: "Referencia del plan de estudios",
    curriculumBody: "Consulta todos los temas y palabras que aprenden tus alumnos, en orden.",
    curriculumLink: "Abrir la referencia del plan de estudios",
    profileTitle: "Tu perfil de profesor",
    profileBody: "Así aparecerás en el directorio de profesores de Speafy cuando se lance.",
    profileBio: "Biografía breve",
    profileBioPh: "Una o dos frases sobre ti y cómo enseñas.",
    profilePhoto: "Foto",
    photoChoose: "Elegir foto",
    photoUploading: "Subiendo…",
    photoRemove: "Quitar",
    photoHint: "PNG o JPG, hasta 200 KB.",
    photoTypeErr: "Elige una imagen PNG o JPG.",
    photoSizeErr: "Esa imagen supera los 200 KB; elige una más pequeña.",
    photoUploadErr: "No se pudo subir. Inténtalo de nuevo.",
    profileLink: "Sitio web personal o enlace a redes sociales",
    profileLinkPh: "www.ejemplo.com",
    profileLanguages: "Idiomas que enseño",
    profileLanguagesHint: "Elige los idiomas que enseñas. Se habilitarán más a medida que Speafy los añada como idiomas del curso.",
    profileLanguagesSoon: "Próximamente",
    save: "Guardar",
    saving: "Guardando…",
    saved: "Guardado",
    urlError: "Eso no parece una dirección web. Revísala o deja el campo en blanco.",
    termsStatusAccepted: "Términos de socio docente — Aceptados el {date}",
    termsStatusPending: "Términos de socio docente — Aún no aceptados",
    termsVersionLabel: "Versión {version}",
    termsView: "Ver los Términos aceptados",
    payoutTitle: "Pago",
    payoutLoading: "Cargando el estado de tu pago…",
    payoutError: "No pudimos cargar el estado de tu pago en este momento.",
    payoutBalance: "Tu saldo actual: {balance}",
    payoutNotEligible: "Podrás solicitar un pago cuando tu saldo alcance {threshold}.",
    payoutAlreadyRequested: "Pago solicitado — nos pondremos en contacto.",
    requestPayoutBtn: "Solicitar pago",
    payoutRequestFailed: "Ocurrió un error al enviar tu solicitud. Inténtalo de nuevo.",
    payoutConfirmTitle: "¿Solicitar un pago?",
    payoutConfirmBody: "Actualmente tienes {balance} disponibles para solicitar.\n\nEsto inicia un proceso de pago manual — no se mueve dinero automáticamente. Revisaremos tu solicitud y te contactaremos por correo electrónico.",
    payoutConfirmBtn: "Solicitar pago",
    payoutConfirmCancel: "Cancelar",
  },

  teacherTerms: {
    screenTitle: "Términos de socio docente",
    contents: "Contenido",
    lastUpdatedLabel: "Última actualización",
    effectiveLabel: "Fecha de entrada en vigor",
    bannerTitle: "Acción necesaria",
    bannerBody: "Revisa y acepta los Términos de socio docente para seguir siendo socio.",
    bannerCta: "Revisar y aceptar",
    acceptedOn: "Aceptaste estos Términos el {date}.",
    acceptedVersion: "Versión aceptada: {version}",
    accepting: "Registrando tu aceptación…",
    acceptError: "No hemos podido registrar tu aceptación ahora mismo. Inténtalo de nuevo.",
    draftNotice: "Estos Términos aún no son definitivos. Podrás aceptarlos cuando se fije la fecha de entrada en vigor.",
  },
};

export default es;
